/* eslint-disable default-case */
import React from 'react';
import { createRoot } from 'react-dom/client';
import Homepage from './features/Homepage';
import { CookiesProvider } from 'react-cookie';
import { MsalProvider } from '@azure/msal-react';

import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { authConfig } from '../src/features/Authentification/authProvider';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

export const msalInstance = new PublicClientApplication(authConfig);
const accounts = msalInstance.getAllAccounts();

if (accounts.length > 0) {
  msalInstance.setActiveAccount(accounts[0]);
}

msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
    const account = event.payload.account;
    msalInstance.setActiveAccount(account);
  }
});

root.render(
  <MsalProvider instance={msalInstance}>
    <CookiesProvider defaultSetOptions={{ path: '/' }}>
      <Homepage />
    </CookiesProvider>
  </MsalProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
